import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { baseURL } from "../Constant";

export const ModelSlice = createSlice({
 name: "model",
 initialState: {
  error: false,

  isSubmitted: null,
  campaignID: 0,
  launchCampaignVal: null,
  campaignValue: null,
  campaignList: "",
  mailList: "",
 },
 reducers: {
  setSubmission: (state, { payload }) => {
   state.isSubmitted = payload;
   state.campaignID = 0;
  },
  setSubmissionAfterApprovel: (state, { payload }) => {


   state.isSubmitted = null;
  },
  setUserID: (state, { payload }) => {
   state.userID = payload;
  },
  setCampainID: (state, { payload }) => {
   state.campaignID = payload.campaignID;
   state.campaignValue = payload.val;
  },
  setCampaignList: (state, { payload }) => {
   state.campaignList = payload;
  },
  setMailList: (state, { payload }) => {
   let finalNames = payload.map((name) => name.programname);

   state.mailList = finalNames;
  },

  setError: (state) => {
   state.error = true;
  },
 },
});

// Action creators are generated for each case reducer function
export const {
 setError,
 setSubmission,
 setSubmissionAfterApprovel,
 setUserID,
 setCampainID,
 setCampaignList,
 setMailList,
} = ModelSlice.actions;

export default ModelSlice.reducer;

export function handleApproverSubmission(data) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/sendtoapproval`, { data },{
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        })
   .then((response) => {
    dispatch(setSubmission(true));
   })
   .catch((err) => {
    console.error("upload fail", err);
    dispatch(setSubmission(false));
   });
 };
}
export function resetSubmissionButton() {
 return (dispatch) => {
  console.log("in here dispacth");

  dispatch(setSubmissionAfterApprovel());
 };
}
export function handleUserIDSave(val) {
 return (dispatch) => {
  dispatch(setUserID(val));
 };
}

export function handleCampainIDSelection(campaignID, val) {
 return (dispatch) => {
  dispatch(setCampainID({ campaignID, val }));
 };
}

export function fetchCampaignsData(val) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/campaignDetail`, { val })
   .then((response) => {
    if (response.status == 201) {
     dispatch(setCampaignList(""));
    } else {
     dispatch(
      setCampaignList(response.data?.filter((campaign) => campaign.status !== "Declined"))
     );
    }
   })
   .catch((err) => {
    console.error("upload fail", err);
   });
 };
}
export function fetchMailList(campaignID, mailerChild) {
 return (dispatch) => {
  axios
   .post(`${baseURL}/fetchMaillist`, { campaignID, mailerChild })
   .then((response) => {
   

    if (response.status == 201) {
     dispatch(setMailList(""));
    } else {
     dispatch(
      setMailList(response.data?.filter((campaign) => campaign.status !== "Declined"))
     );
    }
   })
   .catch((err) => {
    console.error("upload fail", err);
   });
 };
}
